import { render, staticRenderFns } from "./StudyCaseBody.vue?vue&type=template&id=909507d8&scoped=true"
import script from "./StudyCaseBody.vue?vue&type=script&lang=ts"
export * from "./StudyCaseBody.vue?vue&type=script&lang=ts"
import style0 from "./StudyCaseBody.vue?vue&type=style&index=0&id=909507d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@4.3.0_lodash@4.17.21_prettier@2.8.8_react-dom@18.3.1_react@17.0_5ioacul63gvtxmolb2qhpey7py/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909507d8",
  null
  
)

export default component.exports